// libraries
import React from 'react'
import clsx from 'clsx'

// svg
import { GeneralSpinner } from '/react4xp/components/Svg/Icons/General'

// prop types
interface ButtonProps {
    isSolid?: boolean
    href?: string
    target?: boolean
    type?: 'button' | 'submit'
    isLoading?: boolean
    smallBorders?: boolean
    noBorders?: boolean
    noUnderline?: boolean
    bigButton?: boolean
    className?: string
    children: React.ReactNode
    onClick?: (e: React.MouseEvent<HTMLButtonElement> | React.MouseEvent<HTMLAnchorElement>) => void
    disabled?: boolean
}

export default function Button({
    isLoading,
    smallBorders,
    bigButton,
    href,
    target,
    type,
    children,
    isSolid,
    noBorders,
    noUnderline,
    className,
    onClick,
    ...rest
}: ButtonProps) {

    // check if the element is a link or a button based on the presence of href
    const Element = href ? 'a' : 'button'

    const elementProps = {
        href: href || null,
        target: target ? '_blank' : undefined,
        type: Element === 'button' ? type : undefined,
        onClick: onClick || undefined,
        className: clsx(
            'button',
            smallBorders && 'button-small-borders',
            noBorders && 'no-borders',
            isSolid && 'bg-black white',
            noUnderline && 'no-underline',
            bigButton && 'button-big',
            type === 'submit' && 'button--submit',
            className
        ),
        ...rest
    }

    return (
        <Element {...elementProps}>

            {type === 'submit' ? (
                <>
                    <span className='button__spinner'>
                        <GeneralSpinner variant='outline' />
                    </span>

                    <span className='relative z0'>
                        {children}
                    </span>
                </>
            ) : (
                <div className={clsx(
                    'button__content',
                    isLoading && 'button__content--loading'
                )}>

                    {isLoading && (
                        <span className='button__spinner'>
                            <GeneralSpinner variant='outline' />
                        </span>
                    )}

                    <span className='button__text relative z0'>
                        {children}
                    </span>
                    
                </div>
            )}
            
        </Element>
    )
}